var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.view == 'avanzado')?_c('b-card',{staticClass:"m-t-15 m-b-15 s-1",attrs:{"header":"Avanzado"}},[_c('model-form',{attrs:{"input_full_width":"","show_btn_delete":false,"model":_vm.model,"properties":_vm.modelPropertiesFromName('configuration'),"model_name":"configuration"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }